"use client"
import React, { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import store, { persistor } from '../redux/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import Preloader from '@/components/common/Preloader';
import { isPublicContentPath } from '@/lib/seo/publicRoutes';

const ReduxProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isPublicPage = isPublicContentPath(usePathname());

  useEffect(() => {
    persistor.persist();
  }, []);

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        {(bootstrapped) => isPublicPage || bootstrapped ? children : <Preloader />}
      </PersistGate>
    </Provider>
  );
};

export default ReduxProvider;
